require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tutorials-examples-dining-philosophers.json") })
        }
      }, "path---tutorials-examples-dining-philosophers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tutorials-examples-dining-philosophers!./.cache/json/tutorials-examples-dining-philosophers.json
// module id = 773
// module chunks = 231608221292675